<template>
  <td :class="{'positive-number': column.id === 'added_amount' && item.added_amount.value, 'negative-number': column.id === 'withdraw_amount' && item.withdraw_amount.value}">
    <template v-if="column.id === 'date_user'">
      {{ item.date_user.value }}
    </template>

    <template v-if="column.id === 'amount_before'" >
      <span style="display: inline-block; width: 100%; text-align: right">{{ item.amount_before.value }}</span>
    </template>

    <template v-if="column.id === 'added_amount' && item.added_amount.value">
      <span style="display: inline-block; width: 100%; text-align: right">{{ item.added_amount.value }}</span>
    </template>

    <template v-if="column.id === 'withdraw_amount' && item.withdraw_amount.value">
      <span style="display: inline-block; width: 100%; text-align: right">{{ item.withdraw_amount.value }}</span>
    </template>

    <template v-if="column.id === 'amount_after'">
      <span style="display: inline-block; width: 100%; text-align: right">{{ item.amount_after.value }}</span>
    </template>

    <template v-if="column.id === 'transaction_type'">
      {{ item.transaction_type.value }}
    </template>
  </td>
</template>

<script>
import SvgIcon from "@/components/svg-icon";
import CButton from "@/components/controls2/Button";
import WorkerOrUser from "@/components/user/worker-or-user";

export default {
  components: { SvgIcon, CButton, WorkerOrUser },
  props: ["column", "date", "operation", "edit", "canRemove"],
  computed: {
    view() {
      if (!this.operation) return "group-header";
      if (this.date.resume) return "group-item";
      return "operation";
    },

    item() {
      return this.operation || this.date.resume;
    },
    hasBonus() {
      return this.column.id === "bonus" && this.item.bonus > 0;
    },
    hasPenalty() {
      return this.column.id === "penalty" && this.item.penalty < 0;
    },

    classes() {
      return [
        this.column.className,
        (this.hasBonus || this.hasPenalty) && "h-table__cell",
        this.hasBonus && "h-table__cell-positive",
        this.hasPenalty && "h-table__cell--negative",
      ]
        .filter(Boolean)
        .join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
.account-history {
  &__date {
    min-width: 115px;
    text-align: right;
  }

  td.account-history__date {
    padding-left: 12px;
  }

  &__balance-start {
    min-width: 80px;
    text-align: right;
  }

  &__main {
    min-width: 85px;
    text-align: right;
  }

  &__dynamic {
    min-width: 85px;
    text-align: right;
  }

  &__bonus {
    min-width: 80px;
    text-align: right;
  }

  &__fine {
    min-width: 80px;
    text-align: right;
  }

  &__amount {
    min-width: 75px;
    text-align: right;
  }

  &__balance-end {
    min-width: 80px;
    text-align: right;
  }

  &__author {
    min-width: 150px;
  }

  &__reason {
  }

  &__calculation {
    min-width: 40px;
    /deep/ {
      .c-button {
        overflow: hidden;
        margin: auto;
      }
    }
  }

  .operation-comment {
    margin-top: 6px;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 1.2;

    &__icon {
      margin-right: 8px;
      flex-shrink: 0;
    }
  }

  .operations-date {
    &__opener {
      transition: transform 250ms ease-in-out;
      transform: rotate(0);
      margin-right: 10px;
    }
    &--open {
      .operations-date__opener {
        transform: rotate(180deg);
      }
    }
  }
}

.positive-number {
  background-color: #D0F4E3;
  display: table-cell;
  
  &::before {
    display: none;
  }
}
.negative-number {
  background-color: #FFE6F2;
  display: table-cell;
}
.h-table__cell {
  position: relative;
}
</style>
